<template>
  <div class="content__body" ref="scrollContent">
    <ui-loading-circle v-if="isLoading" />
    <div v-else>
      <template>
        <content-box class="content__withdraw can-deactivate" :width="'800px'">
          <div class="title--wrap">
            <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.header.title')"></p>
            <strong v-html="$t('userInfo.myInformation.deactivateInfo.header.desc')"></strong>
          </div>
          <div class="desc--wrap">
            <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc1')"></p>
            <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc2')"></p>
          </div>
          <div class="analytics-page--wrap">
            <dl class="clearfix">
              <dt v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title')"></dt>
              <dd v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.desc1')"></dd>
              <dd v-html="$t(`userInfo.myInformation.deactivateInfo.can.analyticsPage.desc2.${beusablePageCount > 1 ? 'plural' : 'singular'}`, {beusablePageCount: beusablePageCount})"></dd>
            </dl>
          </div>
          <div class="chk-box--wrap">
            <ui-checkbox :value="model.withDrawAgree"
                         @input="onChangeCheckboxValue">
              {{ $t('userInfo.myInformation.deactivateInfo.can.analyticsPage.checkbox') }}
            </ui-checkbox>
            <strong v-if="modelError" class="validation-text">{{ $t('common.validationErrorText.deactivateConfirm') }}</strong>
          </div>
        </content-box>
        <div class="button--wrap">
          <ui-button class="btn__cancel"
                     @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
          <ui-button :primary="true"
                     @click="onShowConfirmDeleteLayer">{{ $t('common.confirm') }}</ui-button>
        </div>
        <back-to-top :refName="'scrollContent'" />
      </template>
    </div>
    <dimmed v-if="useDimmed">
      <deactivate
        v-if="isShowConfirmDeleteLayer"
        @onCloseLayer="isShowConfirmDeleteLayer = false"/>
    </dimmed>
  </div>
</template>

<script>
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import BackToTop from '@/components/ui/BackToTop'
import UiCheckbox from '@/components/ui/UiCheckbox'
import Dimmed from '@/components/ui/Dimmed'
import Deactivate from '@/components/user-info/my-information/Deactivate'
import { deactivateInfo } from '@/api/user'
import { mapState } from 'vuex'
import { getDialog } from '@/libs/vue-utils'

const openDialog = getDialog('dialogType')

export default {
  components: {
    UiLoadingCircle,
    ContentBox,
    UiButton,
    BackToTop,
    UiCheckbox,
    Dimmed,
    Deactivate
  },
  data () {
    return {
      isLoading: true,
      isShowConfirmDeleteLayer: false,
      model: {
        withDrawAgree: false
      },
      modelError: false,
      beusablePageCount: 0,
      deactivateInfo: null
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    useDimmed () {
      return this.isShowConfirmDeleteLayer
    }
  },
  methods: {
    onCancelDeactivate () {
      this.$emit('closeWithdraw')
    },
    onChangeCheckboxValue () {
      this.model.withDrawAgree = !this.model.withDrawAgree
      this.modelError = false
    },
    onShowConfirmDeleteLayer () {
      if (!this.model.withDrawAgree) {
        this.modelError = true
        return false
      }
      this.isShowConfirmDeleteLayer = true
    }
  },
  created () {
    deactivateInfo().then(response => {
      this.deactivateInfo = response
      this.beusablePageCount = response.beusable_page_count
      this.isLoading = false
    }).catch(err => {
      console.error(err)
      this.isLoading = false
      openDialog('common.error')
    })
  }
}
</script>

<style lang="scss" scoped="scoped">
  .content__body {
    height: calc(100vh - 166px);
    padding-top: 30px;
    overflow-y: auto;
    text-align: center;

    .content__withdraw {
      margin: 0 auto;
      padding: 60px 25px;
      color: #444;
      border: solid 2px #ec0047;

      &.no-deactivate {
        padding-bottom: 27px;
      }

      &.can-deactivate {
        .title--wrap {
          border-bottom: 1px solid #d8d8d8;
          padding-bottom: 28px;
        }
      }

      .title--wrap {
        width: 700px;
        margin: 0 auto;

        .title {
          font-size: 22px;
          font-weight: bold;
          line-height: 1.45;
        }
        strong {
          display: inline-block;
          margin-top: 25px;
          font-size: 15px;
          font-weight: bold;
          line-height: 1;
          color: $brandColor;
        }
      }

      .desc--wrap {
        padding-top: 50px;
        padding-bottom: 20px;

        p {
          &:nth-of-type(1) {
            font-size: 15px;
            font-weight: bold;
          }
          &:nth-of-type(2) {
            margin-top: 25px;
            font-size: 14px;
            line-height: 1.43;
          }
        }
      }

      .analytics-page--wrap,
      .current-plan--wrap {
        margin: 0 auto;
        width: 750px;
        border: solid 8px #e6e6e6;
        padding: 32px;
        text-align: left;
        box-sizing: border-box;
      }

      .analytics-page--wrap {
        dl {
          position: relative;
          dt {
            position: absolute;
            top: 0;
            left: 0;
            font-size: 15px;
            font-weight: bold;
            color: $brandColor;
          }
          dd {
            float: right;
            width: 500px;
            font-size: 14px;

            &:not(:nth-of-type(1)) {
              margin-top: 16px;
            }
          }
        }
      }

      .current-plan--wrap {
        height: 260px;
        text-align: center;
        margin-top: 38px;

        & > div {
          height: 167px;
          @include flexYcenter;
        }

        .desc {
          font-size: 14px;
          line-height: 1.43;
          color: #444444;
        }

        ul {
          width: 420px;
          margin: 0 auto;

          li {
            white-space: nowrap;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:nth-of-type(2) {
              padding-top: 13px;
              margin-top: 13px;
              border-top: 1px dashed #d7d7d7;
            }

            & > * {
              width: 33% !important;
            }

            .cancel-subscription {
              position: relative;
              height: 38px;

              .ui-btn {
                position: absolute;
                top: 0;
                right: 0;
              }
            }
          }

          .icon--logo-red {
            width: 90px;
            height: 14px;
            background-size: contain;
          }
          .plan-name {
            font-size: 16px;
            font-weight: bold;
            color: #444444;
            width: 70px;
            text-align: center;
            display: inline-block;
            white-space: nowrap;
          }
          .expire-date {
            text-align: right;
            display: inline-block;
            width: 150px;
          }
          .ui-btn {
            font-size: 13px;
            font-weight: bold;
            color: #444444;
          }
        }
      }

      .chk-box--wrap {
        position: relative;
        margin-top: 25px;

        .validation-text {
          @include validErrorText;
          position: absolute;
          left: 50%;
          bottom: -20px;
          transform: translateX(-50%);
        }
      }
    }

    .button--wrap {
      margin-top: 30px;
      margin-bottom: 127px;
      text-align: center;

      .btn__cancel {
        margin-right: 5px;
      }
    }
  }
</style>
